import React from 'react';
import Header from './Header';

// Contenitore standard delle pagine admin: colonna centrata con logo in testa
function Page({ children }) {
  return (
    <div style={styles.container}>
      <Header />
      {children}
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    width: '100%',
    maxWidth: '1000px',
    boxSizing: 'border-box',
  },
};

export default Page;
